<template>
  <div
    ref="inputWrapper"
    :class="{
      blured: (hasBlured || validate),
      'input-lancar-notas': true,
      'lancar-notas-error': hasError && (hasBlured || validate),
      'lancar-notas-pulsar': hasError && (pulsarError || validate),
      'lancar-notas-loading': loading,
    }"
  >
    <input
      :type="type"
      ref="input"
      :disabled="disabled"
      :value="value"
      v-bind="$attrs"
      :max="tratarMax()"
      :maxlength="maxlength"
      @input="onInput"
      @keypress="justNumbers"
      @keydown="(event) => $emit('keydown', event)"
      @blur="hasBlured = true"
      :step="step"
    />
    <div class="input-lancar-notas-disabled"></div>
    <div class="lancar-notas-loading-front" v-if="loading"></div>
    <div v-if="hasError" class="lancar-notas-tooltip-error">
      <div class="lancar-notas-error-bloco">
        <ul v-for="msgError in msgsError" :key="msgError.id">
          <li>{{ msgError }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputCota",
  props: {
    value: [String, Number],
    step: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: [String],
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    msgsError: {
      type: Array,
      default() {
        return ["formato invalido"];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pulsarError: {
      type: Boolean,
      default: true,
    },
    maxlength: {
      type: [String, Number],
      default: "",
    },
    validate: [Boolean]
  },
  data() {
    return {
      hasBlured: false,
    };
  },
  mounted() {
    let input = this.$refs.input;
    input.addEventListener("drop", (e) => e.preventDefault());
    input.addEventListener("paste", (e) => e.preventDefault());
  },
  methods: {
    onInput(event) {
      this.$emit("input", event.target.value);
    },
    tratarMax() {
      if (this.type == "date") {
        return "2999-12-31";
      }
    },
    exibirError() {
      return this.msgsError.length > 0;
    },
    justNumbers(event) {
      const currentCode = event.which || event.code;
      let currentKey = event.key;
      if (!currentKey) {
        currentKey = String.fromCharCode(currentCode);
      }
      if (
        !currentKey.match(/[0-9.]/) ||
        (currentKey == "." && this.value.includes("."))
      ) {
        event.preventDefault();
      }
    },
  },
  computed: {
    hasError() {
      return (
        this.value == null ||
        this.value?.toString() == "" ||
        this.value?.toString().endsWith(".") ||
        this.value?.toString().endsWith(",")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.input-lancar-notas {
  width: 70px;
  height: 30px;
  border-radius: 4px;
  display: inline-flex;
  position: relative;

  input[type="number"] {
    appearance: textfield;
    margin: 0;
  }

  input {
    color: black;
    display: flex;
    border: none !important;
    background-color: transparent;
    z-index: 1;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 1rem;
    line-height: 1.75rem;
    font-weight: 400;
    letter-spacing: 0.00937em;
    text-decoration: inherit;
    text-transform: inherit;
    -ms-flex-item-align: end;
    align-self: flex-end;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 0;
    appearance: none;
    text-align: center;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &:focus {
      outline: none;
      & + .input-lancar-notas-disabled {
        border-width: 2px;
        border-color: #009688;
      }
    }

    &:disabled + .input-lancar-notas-disabled {
      background-color: #94949424;
    }
  }

  .input-lancar-notas-disabled {
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 4px;
    border: 1px solid #757575;
    -webkit-transition: all 0.1s ease-out;
    -moz-transition: all 0.1s ease-out;
    -o-transition: all 0.1s ease-out;
    transition: all 0.1s ease-out;
  }

  .lancar-notas-tooltip-error {
    min-width: 150px;
    position: absolute;
    z-index: 2;
    //margin-left: calc(-100%);
    margin-top: 23px;
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
    opacity: 0;
    display: block;
    text-align: left;

    .lancar-notas-error-bloco {
      background: #e22e2ed9;
      border-radius: 2px;
      color: #fff;
      font-size: 12px;
      display: inline-block;
      padding: 5px 8px;
      text-transform: initial;
      width: auto;
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
        0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    }
  }
}

.lancar-notas-error .input-lancar-notas-disabled {
  border-color: #009688 !important;
  border-width: 2px;
}

.lancar-notas-error.blured .input-lancar-notas-disabled {
  border-color: #b00020 !important;
  border-width: 2px;
}

.lancar-notas-error.blured input:hover ~ .lancar-notas-tooltip-error {
  display: block;
  margin-top: 32px;
  opacity: 1;
}

.lancar-notas-pulsar {
  animation: none;
}
.blured.lancar-notas-pulsar {
  animation: pulsar 2s;
}

.lancar-notas-loading-front {
  border: 2px solid green !important;
  box-sizing: border-box;
  border-width: 2px;
  animation: clipMe 1s infinite;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

@keyframes pulsar {
  0%,
  40%,
  80% {
    opacity: 0;
  }
  20%,
  60%,
  100% {
    opacity: 1;
  }
}

@keyframes loading {
  to {
    stroke-dashoffset: -5;
  }
}

@keyframes clipMe {
  0%,
  100% {
    clip: rect(0px, 70px, 2px, 0px);
  }
  25% {
    clip: rect(0px, 70px, 30px, 67px);
  }
  50% {
    clip: rect(27px, 70px, 30px, 0px);
  }
  75% {
    clip: rect(0px, 2px, 30px, 0px);
  }
}
</style>
